import React from 'react';
import styles from './Color.scss';

const ColorIcon = ({ color }) => (
  <div className={styles.icon} style={{ backgroundColor: color }} />
);

export default ColorIcon;
